import cn from 'clsx';
import { IconLookup } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type Props = {
  title: string;
  icon: IconLookup;
  href?: string;
  onClick?: () => void;
  target?: string;
  className?: string;
};

export default function HelpLink({ href, onClick, target, icon, title, className }: Props) {
  return (
    <a
      target={target}
      href={href}
      onClick={onClick}
      className={cn(
        'block px-3 py-2 rounded-md cursor-pointer',
        'border-[1.5px]',
        'border-slate-200 hover:border-slate-300 active:border-slate-400',
        'bg-white hover:bg-slate-100 active:bg-slate-200',
        'text-slate-800 hover:text-slate-900 active:text-slate-950',
        className
      )}
    >
      <div className="flex flex-col items-center justify-center">
        <FontAwesomeIcon icon={icon} className="mb-1 mt-0.5 text-lg" />
        <div className="font-semibold text-sm">{title}</div>
      </div>
    </a>
  );
}
